import { render, staticRenderFns } from "./InfoBar.vue?vue&type=template&id=0c6fa005&scoped=true&"
import script from "./InfoBar.vue?vue&type=script&lang=ts&"
export * from "./InfoBar.vue?vue&type=script&lang=ts&"
import style0 from "./InfoBar.vue?vue&type=style&index=0&id=0c6fa005&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6fa005",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/p00353_hh-ballett/client-player/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c6fa005')) {
      api.createRecord('0c6fa005', component.options)
    } else {
      api.reload('0c6fa005', component.options)
    }
    module.hot.accept("./InfoBar.vue?vue&type=template&id=0c6fa005&scoped=true&", function () {
      api.rerender('0c6fa005', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/InfoBar.vue"
export default component.exports